import { render, staticRenderFns } from "./PointsSettings.vue?vue&type=template&id=7695096e&scoped=true"
import script from "./PointsSettings.vue?vue&type=script&lang=js"
export * from "./PointsSettings.vue?vue&type=script&lang=js"
import style0 from "./PointsSettings.vue?vue&type=style&index=0&id=7695096e&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7695096e",
  null
  
)

export default component.exports